/**
 * Constants for plan names used throughout the application
 */

export const PLAN_NAMES = {
  // Plan Ids
  LIVE_WEBINARS: 'Live-Webinars',
  AUTOMATED_GOLD: 'Automated-Gold', 
  ALL_IN_ONE: 'All-In-One',
  FREE_TRIAL: 'free-trial-plan',
  
  // Formatted display names
  LIVE_WEBINARS_DISPLAY: 'Launch',
  AUTOMATED_GOLD_DISPLAY: 'Scale',
  ALL_IN_ONE_DISPLAY: 'Professional',
  FREE_TRIAL_DISPLAY: 'Free'
}; 